import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import toJS from '../../../hoc/toJS'
import EditNewsletterElement from '../../PageEditItem/present/EditNewsletterElement'
import { NEWSLETTER_ELEMENT_IMAGE_DEFAULT, NEWSLETTER_ELEMENT_TEXT_DEFAULT } from '../../../constants/state'
import { newsletterCreateItem } from '../../../actions'


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateElement: (itemType, itemData) => {
        dispatch(newsletterCreateItem(itemType, itemData))
    }
})


const AddNewsletterElementContainer = ({itemType, closePagePath, onUpdateElement}) => {
    const isText = 'text' === itemType


    return <EditNewsletterElement
        itemData={isText ? NEWSLETTER_ELEMENT_TEXT_DEFAULT : NEWSLETTER_ELEMENT_IMAGE_DEFAULT}
        itemType={itemType}
        closePagePath={closePagePath}
        onUpdateItem={onUpdateElement}
    />
}


export default compose(
    connect(null, mapDispatchToProps),
    toJS()
)(AddNewsletterElementContainer)